module.exports = __webpack_public_path__ + "static/media/02.32714109.webp";